module.exports = __webpack_public_path__ + "static/media/canari_logo_fireworks.09ba9626.png";